import { reduxMultiple } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxMultiple.HR.EMPLOYMENT()
export { reducer, actions, saga }
